import React, { useRef, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useGetShowInMenuCourseCategoriesByParentQuery } from "../../../../features/courseCategories/courseCategoriesAPI";
import { IoIosArrowForward } from "react-icons/io";
import { Link } from "react-router-dom";
import style from "./Category.module.css";

const ChildCategories = ({ parentId, anchorRect }) => {
    const { data, isLoading, isError } =
        useGetShowInMenuCourseCategoriesByParentQuery(parentId);
    const { data: responseData } = data || {};
    const { data: categories } = responseData || {};

    const [position, setPosition] = useState({ top: 0, left: 0 });

    useEffect(() => {
        if (anchorRect) {
            setPosition({
                top: anchorRect.bottom, // below parent
                left: anchorRect.left
            });
        }
    }, [anchorRect]);

    if (isLoading || isError || !categories?.length) return null;

    return createPortal(
        <ul
            className={`${style.child} z-50 absolute`}
            style={{
                top: `${position.top}px`,
                left: `${position.left}px`,
                position: "fixed"
            }}
        >
            {categories.map((cat) => (
                <SubMenuItem key={cat.id} category={cat} />
            ))}
        </ul>,
        document.body
    );
};

const SubMenuItem = ({ category }) => {
    const { id, name, slug, childCount } = category || {};
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const [rect, setRect] = useState(null);
    let timer;

    const handleMouseEnter = () => {
        clearTimeout(timer);
        if (ref.current) {
            setRect(ref.current.getBoundingClientRect());
        }
        setOpen(true);
    };

    const handleMouseLeave = () => {
        timer = setTimeout(() => setOpen(false), 200); // delay close
    };

    return (
        <li
            ref={ref}
            className="relative px-3 py-2 hover:bg-gray-100 flex justify-between items-center"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <Link to={`/${slug}/courses`} className="flex-1">
                {name}
            </Link>
            {childCount > 0 && <IoIosArrowForward />}

            {open && childCount > 0 && (
                <SubChildCategories parentId={id} anchorRect={rect} />
            )}
        </li>
    );
};

const SubChildCategories = ({ parentId, anchorRect }) => {
    const { data, isLoading, isError } =
        useGetShowInMenuCourseCategoriesByParentQuery(parentId);
    const { data: responseData } = data || {};
    const { data: categories } = responseData || {};

    const [position, setPosition] = useState({ top: 0, left: 0 });

    useEffect(() => {
        if (anchorRect) {
            setPosition({
                top: anchorRect.top,
                left: anchorRect.right
            });
        }
    }, [anchorRect]);

    if (isLoading || isError || !categories?.length) return null;

    return createPortal(
        <ul
            className={`${style.child} z-50 absolute`}
            style={{
                top: `${position.top}px`,
                left: `${position.left}px`,
                position: "fixed"
            }}
        >
            {categories.map((cat) => (
                <li key={cat.id} className="px-3 py-2 hover:bg-gray-100">
                    <Link to={`/${cat.slug}/courses`}>{cat.name}</Link>
                </li>
            ))}
        </ul>,
        document.body
    );
};

export default ChildCategories;
